module.exports = __webpack_public_path__ + "static/media/fondoGarantiaBg.ea3b8308.png";